//In your react App.js or yourComponent.js file add these lines to import

import React from 'react';

import * as Survey from "survey-react";
import * as widgets from "surveyjs-widgets";
import showdown from 'showdown';
import { putFormData } from '../../services/dataService';
import objectsAreEqual  from '../../services/equalityCheckerService';
import * as SaveResult from './SaveResultConstants';

import '../../bootoast/bootoast.css';
import bootoast from '../../bootoast/bootoast';
import "survey-react/survey.css";
import "survey-react/modern.css";
import "./Questionnaire.css";

import {convertToLocalDateTimeString} from '../../services/helpers';

widgets.inputmask(Survey);


const AUTO_SAVE_INTERVAL = 1000 * 60  * 90 

class QuestionnaireForm extends React.Component {

    constructor() {
        super();
        this.state = { loading: true };
        this.converter = new showdown.Converter();
        this.model = new Survey.Model();
        
        Survey.Serializer.addProperty("question", {
            name: "columnId:number",
            default: 0,
        });

        Survey.Serializer.addProperty("question", {
            name: "inputWidth:string",
            default: "",
        });

        Survey.Serializer.addProperty("question", {
            name: "elementId:number",
            default: 0,
        });


    }

    intervalId = null;

    componentWillUnmount(){
        if(this.intervalId)
            clearInterval(this.intervalId);
      }



    performAutoSave=async()=>{
        if(!objectsAreEqual(this.originalData,this.model.data)){
            this.originalData = JSON.parse(JSON.stringify(this.model.data));
            await this.saveData(false,true);
            bootoast.toast({
                position: 'left-top',
                message: `Autosaved information`,
                type: 'success',
                timeout: 7
              });
        }
            
    }

    clearIntervalIfNecessary=()=>{
        if(this.intervalId)
            clearInterval(this.intervalId);
    }



    //Define a callback methods on survey complete
    onComplete = async (survey, options) => {

        try{
            if(!survey.isLastPage)
                return options.complete(); //Confusing, but basically it's survey.js saying if the user is NOT hitting the 
                                           // complete button(submitted while on last page) return now there are no errors (we don't check server side on page navigation)
                                                           
            await this.saveData(true);
            this.setState({ isComplete: true });
            this.props.handleRefresh(SaveResult.COMPLETED);                              
        }
        catch(err){
            var saveError = err;
            if(saveError && saveError.response && saveError.response.data &&  saveError.response.data.type ==="FailedValidation"){

                console.log(saveError.response.data.validationIssues.map(m=>"<li>"+ m +"</li>"));
                var toast = bootoast.toast({
                    position: 'top',
                    message: 'Could not save because there were validation issues ' + this.makeErrorList(saveError.response.data.validationIssues),
                    type: 'danger',
                    timeout: 10
                  });

                console.log(toast);
            }
            else{
                bootoast.toast({
                    position: 'top',
                    message: `Error saving form, try again, and if you receive this messge please contact Central Support at centralsupport@pcrb.com`,
                    type: 'danger',
                    timeout: 7
                  });
                
            }

              this.model = new Survey.Model(this.model.data);
              console.log(saveError);
        }


    }

    makeErrorList=(errors)=>{

        var items = errors.map(m=>"<li>"+ m +"</li>");
        return `<ul>${items.join('')}</ul>`;
    }

    setFormData(formAndResponses) {
        if (Object.keys(formAndResponses.responses).length > 0) {
            this.originalData = JSON.parse(JSON.stringify(formAndResponses.responses));
            this.model.data = formAndResponses.responses;
        }
        else {
            this.originalData = JSON.parse(JSON.stringify(this.model.data));
        }

        this.instanceInfo = {
            lastStatus: formAndResponses.status,
            lastUpdated: formAndResponses.lastUpdated,
            lastUpdatedByUserId: formAndResponses.lastUpdatedByUserId
        };
    }

    render() {

        if(this.props.readOnlyMode)
            this.model.mode = "display";
            
        var mainColor = "#0078d4";
        var mainHoverColor = "#60C5FB";
        var textColor = "#4a4a4a";
        var headerColor = "#4a4a4a";
        var headerBackgroundColor = "#4a4a4a";
        var bodyContainerBackgroundColor = "#f8f8f8";

        var defaultThemeColorsSurvey = Survey.StylesManager.ThemeColors["default"];
        defaultThemeColorsSurvey["$main-color"] = mainColor;
        defaultThemeColorsSurvey["$main-hover-color"] = mainHoverColor;
        defaultThemeColorsSurvey["$text-color"] = textColor;
        defaultThemeColorsSurvey["$header-color"] = headerColor;
        defaultThemeColorsSurvey["$header-background-color"] = headerBackgroundColor;
        defaultThemeColorsSurvey[
            "$body-container-background-color"
        ] = bodyContainerBackgroundColor;

        Survey
            .StylesManager
            .applyTheme("default");

        return (
            <div className="questionnaire-form-content">
            { !this.state.loading &&
                <Survey.Survey model={this.model}
                    onDynamicPanelAdded={this.onPanelAdded}
                    onMatrixRowAdded ={this.onTableRowAdded}                
                    onAfterRenderQuestion={this.doesItRender}
                    onMatrixAfterCellRender={this.doesItRender}
                    onAfterRenderQuestionInput={this.resizeInputBox}                    
                    onTextMarkdown={this.doMarkdown}                 
                    onServerValidateQuestions={this.onComplete} />
            }                
            </div>)
    }


    doesItRender = (sender, options) => {
        var input = options.htmlElement.querySelector('input');
        if (input)
            input.setAttribute('autocomplete', 'off');
    };

    onPanelAdded = (sender, options) =>{
        if(options.question.panelCount > 1)
            for (var question of options.question.panels[options.question.panelCount-1].questions){
                question.value = "";
            }
    }
    onTableRowAdded = (sender, options) =>{        
        options.question.setRowValue(options.row.rowIndex-1,{});
           
    }

    resizeInputBox = (sender, options) => {
        if (!options.question.inputWidth) return;
        options.htmlElement.style.width = options.question.inputWidth;
    };

    doMarkdown = (survey, options) => {


        var fixedHtml = this.fixHtmlMarkdownIssueWithSpaces(options.text);

        //convert the mardown text to html
        var str = this.converter.makeHtml(fixedHtml);
        if (str.indexOf("<p>") === 0) {
            //remove root paragraphs<p></p>
            str = str.substring(3);
            str = str.substring(0, str.length - 4);
        }
        //set html
        options.html = str;
    }

    fixHtmlMarkdownIssueWithSpaces = (html) => {
        var beforeAndAfterDecimal = html.split(".");
        if (beforeAndAfterDecimal.length > 1 && !isNaN(beforeAndAfterDecimal[0]) && beforeAndAfterDecimal[1].substr(0, 1) === " ") {
            beforeAndAfterDecimal[1] = ".&nbsp;" + beforeAndAfterDecimal[1].substr(1)
            return beforeAndAfterDecimal.join("");
        }
        return html

    }


    saveData = async (completed, autosave=false) => {       
        
        try {
            
            var newInstanceInfo = await this.saveDataToOverride(completed);        

            this.instanceInfo = {
                lastUpdated: newInstanceInfo.data.lastUpdated, 
                lastUpdatedByUserId:newInstanceInfo.data.lastUpdatedByUserId
            };

            if(!autosave)
                this.clearIntervalIfNecessary();

        } catch (err) {

            if(err.response && err.response.data && err.response.data.type === "ConcurrencyIssue")
            {
                this.clearIntervalIfNecessary();
                alert(this.buildAlertMessage(err.response.data));
                this.props.handleRefresh();   
            }
            
            throw(err);
    
        }
    }

    saveDataToOverride= async (completed) =>{
        return await putFormData({ instanceId: this.currentInstanceId, completed: completed, responseCollection: this.model.data,
            lastUpdatedByUserId: this.instanceInfo.lastUpdatedByUserId, lastUpdated: this.instanceInfo.lastUpdated });  
    }

    buildAlertMessage = ({lastUpdatedNyUserName, lastUpdated}) =>{
        var formattedDate = ". ";
        try {
            formattedDate =  `on ${convertToLocalDateTimeString(lastUpdated)}. `; 
        } catch (error) {
          //Swallow bad dates  
        }
        return `While you were filling out the form, ${lastUpdatedNyUserName} updated it`+               
                `${formattedDate}Hit Ok, and you will be taken back to the form list, and you can open the updated form.`;
    
    
    }


}

    

export default QuestionnaireForm;